import { TypeMatiers } from "common/enums";
import { FC } from "react";

//IMAGES
import ANGLAIS from "assets/images/app/iconMatiers/Anglais.png";
import FRANCAIS from "assets/images/app/iconMatiers/Francais.png";
import HISTOIREGEO from "assets/images/app/iconMatiers/Histoire-geo.png";
import MATH from "assets/images/app/iconMatiers/Mathematiques.png";
import PHILO from "assets/images/app/iconMatiers/Philosophie.png";
import PHYSIQUE from "assets/images/app/iconMatiers/Physique-chimie.png";
import SVT from "assets/images/app/iconMatiers/SVT.png";

type Props = {
  data: any;
};
const IconTopic: FC<Props> = ({ data }) => {
  return (
    <img
      style={{
        position: "relative",
        width: "18px",
        height: "18px",
        top: "-1px",
      }}
      src={
        data?.description || data == TypeMatiers.mathematique
          ? MATH
          : data?.description || data == TypeMatiers.SVT
            ? SVT
            : data?.description || data == TypeMatiers.PhysiqueChimie
              ? PHYSIQUE
              : data?.description || data == TypeMatiers.Philosophie
                ? PHILO
                : data?.description || data == TypeMatiers.HistoireGeo
                  ? HISTOIREGEO
                  : data?.description || data == TypeMatiers.Francais
                    ? FRANCAIS
                    : data?.description || data == TypeMatiers.Anglais
                      ? ANGLAIS
                      : ""
      }
    />
  );
};

export default IconTopic;
